// Which of a source's two rates a gateway converts at, from the source's side of
// the counter: buy is what it pays for one unit, sell what it charges.
export const CURRENCY_RATE_KIND = ['buy', 'sell'];
